module.exports = __webpack_public_path__ + "318b41ed23ffad0303dfd4944543184c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-27.png
// module id = 1676
// module chunks = 0